module.exports = __webpack_public_path__ + "static/media/dogo.0432f01c.png";